export default __webpack_public_path__ + "static/redefine_back-a5d924a8818e8c6129a60d6f920e9d94.webp";